import Api from './api.service'

export default {
  login (credentials) {
    return Api().post('login', credentials)
  },
  logout () {
    return Api().post('logout')
  },
  forgotPassword (credentials) {
    return Api().post('forgot-password', credentials)
  },
}
